import { render } from "./TipoExamen.vue?vue&type=template&id=2680346b&scoped=true"
import script from "./TipoExamen.vue?vue&type=script&lang=js"
export * from "./TipoExamen.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=2680346b&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2680346b"]])

export default __exports__